
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.129 0c3.843 0 6.976 1.352 7.123 3.044l.005.124v3.564a5.926 5.926 0 00-1.583-.85V5.16a7.416 7.416 0 01-1.032.461l-.071-.012a5.913 5.913 0 00-3.819.713l-.23.01-.393.005c-2.108 0-4.002-.407-5.307-1.053l-.238-.124v2.873l.025.024c.138.134.386.337.79.549.558.294 1.428.613 2.734.78a5.921 5.921 0 00-.355 1.55c-1.39-.193-2.397-.55-3.117-.928a6.2 6.2 0 01-.077-.041v2.668a.495.495 0 00.03.088c.044.097.156.288.445.505.47.352 1.432.79 3.342.96a5.979 5.979 0 001.248 1.65c-2.943-.058-4.6-.638-5.54-1.343-.503-.377-.787-.78-.942-1.129a2.03 2.03 0 01-.162-.596l-.003-.03-.001-.026L0 12.675l.12-.001H0V3.167C0 1.418 3.192 0 7.129 0zm3.153 8.786H9.17v5.075h3.379v-.905h-2.267v-4.17zM7.129 1.584c-1.8 0-3.354.328-4.398.792-.524.233-.85.469-1.023.651a.784.784 0 00-.112.141.73.73 0 00.112.141c.173.183.5.42 1.023.652 1.044.464 2.598.791 4.398.791 1.8 0 3.353-.327 4.397-.791.524-.233.85-.47 1.024-.652a.783.783 0 00.111-.14.783.783 0 00-.111-.142c-.174-.182-.5-.418-1.024-.651-1.044-.464-2.597-.792-4.397-.792zm-.911 9.3l-.003.02-.004.032.007-.057a4.545 4.545 0 01.222-.913 4.517 4.517 0 016.006-2.643l.228.104.178.092.092.051.148.09.059.037a4.53 4.53 0 01.45.335l.106.092a4.545 4.545 0 01.551.59 4.515 4.515 0 01-5.757 6.719l-.055-.032a3.554 3.554 0 01-.14-.082c-.025-.017-.05-.034-.077-.05l-.133-.09-.056-.04a4.472 4.472 0 01-.834-.785l-.053-.067a4.495 4.495 0 01-.955-3.22h-.002l.022-.183z"}})])
          )
        }
      }
    